import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";

const getBranchPrice = async (branchId, customerType) => {
  const db = getFirestore();
  const pricesCollection = collection(db, "prices");
  const q = query(
    pricesCollection,
    where("branchId", "==", branchId),
    where("customerType", "==", customerType)
  );

  try {
    console.log(
      `Querying prices for branchId: ${branchId}, customerType: ${customerType}`
    );
    const querySnapshot = await getDocs(q);
    console.log(`Query result: ${querySnapshot.size} documents found`);

    if (!querySnapshot.empty) {
      const pricesData = querySnapshot.docs[0].data();
      console.log(`Found prices data for ${customerType}:`, pricesData);
      return pricesData;
    } else {
      console.log(
        `No prices data found for branchId: ${branchId} and customerType: ${customerType}. Returning empty object.`
      );
      return {};
    }
  } catch (error) {
    console.error(
      `Error fetching branch prices for ${branchId} (${customerType}):`,
      error
    );
    return {};
  }
};

export default getBranchPrice;
